import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, Megaphone, Info, Warning } from "@phosphor-icons/react";
import api from "@/lib/api";

const KEY = "cd_dismissed_announcements";

// On-brand style themes.
const STYLES = {
  information: { bg: "bg-brand-blue", sub: "text-blue-100", accent: "text-blue-200", icon: Info },
  promotion: { bg: "bg-brand-purple", sub: "text-purple-100", accent: "text-purple-200", icon: Megaphone },
  alert: { bg: "bg-brand-teal", sub: "text-teal-50", accent: "text-teal-100", icon: Warning },
};

function getDismissed() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}

export function AnnouncementBanner() {
  const [ann, setAnn] = useState(null);

  useEffect(() => {
    api.get("/announcements").then((r) => {
      const dismissed = getDismissed();
      const active = (r.data || []).find((a) => !dismissed.includes(a.id));
      if (active) setAnn(active);
    }).catch(() => {});
  }, []);

  if (!ann) return null;

  const theme = STYLES[ann.style] || STYLES.information;
  const StyleIcon = theme.icon;

  const dismiss = () => {
    const dismissed = getDismissed();
    dismissed.push(ann.id);
    localStorage.setItem(KEY, JSON.stringify(dismissed));
    setAnn(null);
  };

  return (
    <div data-testid="announcement-banner" data-style={ann.style || "information"} className={`relative z-[60] ${theme.bg} text-white`}>
      <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-2.5 sm:px-6 lg:px-8">
        <StyleIcon size={20} weight="fill" className={`hidden shrink-0 ${theme.accent} sm:block`} />
        <div className="min-w-0 flex-1 text-center text-sm sm:text-left">
          <span className="font-semibold">{ann.title}</span>
          <span className={`mx-2 hidden sm:inline ${theme.accent}`}>•</span>
          <span className={`block sm:inline ${theme.sub}`}>{ann.message}</span>
          {ann.link_url && (
            <Link to={ann.link_url} className="ml-2 inline font-semibold underline underline-offset-2 hover:text-white">
              {ann.link_label || "Learn more"}
            </Link>
          )}
        </div>
        <button
          data-testid="announcement-dismiss"
          onClick={dismiss}
          aria-label="Dismiss announcement"
          className={`shrink-0 rounded-full p-1.5 ${theme.sub} transition-colors hover:bg-white/15 hover:text-white`}
        >
          <X size={18} weight="bold" />
        </button>
      </div>
    </div>
  );
}
